import { useApiFetcherSWR } from "hooks/SwrCustom";


export const API_ENDPOINT = {
  GET_CURRENT_WEEKSTAAT: {
    url: "weekstaat/current",
    method: "get",
  },

  DOWNLOAD_REPORT: {
    url: "download-report",
    method: "get",
  },

  GET_ABSENT_MENTION_USERS: {
    url: "absents-list",
    method: "get",
  },

  UPDATE_WEEKSTAAT_SCHOOL: {
    url: "weekstaat-schools",
    method: "patch",
  },

  GET_WEEKSTAAT_DETAIL: {
    url: "weekstaat",
    method: "get",
  },
};

/* =========================
   GET: Current Weekstaat
========================= */
export const useCurrentWeekstaat = (options = {}) =>
  useApiFetcherSWR(API_ENDPOINT.GET_CURRENT_WEEKSTAAT, options);

/* =========================
   GET: Weekstaat Detail
========================= */
export const useWeekstaatDetail = (wid, wsId, schoolId, options = {}) =>
  useApiFetcherSWR(
    wid && wsId && schoolId
      ? {
          ...API_ENDPOINT.GET_WEEKSTAAT_DETAIL,
          url: `${API_ENDPOINT.GET_WEEKSTAAT_DETAIL.url}/${wid}`,
          params: {
            wsid: wsId,
            schoolId,
          },
        }
      : null,
    options
  );

/* =========================
   GET: Absent Mention Users
========================= */
export const useAbsentMentionUsers = (schoolId, iCommunityId, options = {}) =>
  useApiFetcherSWR(
    schoolId && iCommunityId
      ? {
          ...API_ENDPOINT.GET_ABSENT_MENTION_USERS,
          params: {
            schoolId,
            iCommunityId,
          },
        }
      : null,
    options
  );

/* =========================
   PATCH: Update Weekstaat School
   (USE trigger from hook)
========================= */
export const useUpdateWeekstaatSchool = (id) =>
  useApiFetcherSWR(
    id
      ? {
          ...API_ENDPOINT.UPDATE_WEEKSTAAT_SCHOOL,
          url: `${API_ENDPOINT.UPDATE_WEEKSTAAT_SCHOOL.url}/${id}`,
        }
      : null
  );

/* =========================
   GET: Download Report
   (trigger via SWR fetcher if needed)
========================= */
export const useDownloadWeekstaatReport = (id) =>
  useApiFetcherSWR(
    id
      ? {
          ...API_ENDPOINT.DOWNLOAD_REPORT,
          url: `${API_ENDPOINT.DOWNLOAD_REPORT.url}/${id}`,
        }
      : null
  );